<template>
  <div class="container" @click="onClick">
    <div class="icon"></div>
    <div class="text" v-html="displayText"></div>
  </div>
</template>

<script>
import { EVENT_BUS } from '@/eventBus';

export default {
  name: 'ReportInformationPanel',
  computed: {
    displayText() {
      return this.$t('get.report.on.transactions');
    },
  },
  methods: {
    onClick() {
      EVENT_BUS.$emit('EVENT_GET_REPORT_LIST', 'TRANSACTION');
    },
  },
};
</script>

<style lang="sass" scoped>
  @import './information-panel'

  .container
    &:hover
      border-color: #7CB342

  .icon
    background:
      color: #7CB342
      image: url('~icons/custom/report.svg')
</style>
